import { Grid, makeStyles } from '@material-ui/core';
import CircularProgress, {
  CircularProgressProps,
} from '@material-ui/core/CircularProgress';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import clsx from 'clsx';
import { CompanyData, RolesEnum } from 'modules/authenticate/interfaces';
import { inAdminView, inSuperAdminView, inOperatorView } from 'utils/role';
import styles from './styles';

const useStyles = makeStyles(styles);

interface Props extends CircularProgressProps {
  size?: number;
  companySelected: CompanyData | null;
  role?: RolesEnum;
  smallLoading?: boolean;
}

const Loading: React.FC<Props> = ({
  role,
  companySelected,
  size,
  smallLoading,
  ...props
}: Props) => {
  const classes = useStyles();

  return (
    <Grid
      container
      justify="center"
      className={clsx({
        [classes.button]: size,
        [classes.root]: !size,
        [classes.rootSmaller]: smallLoading,
      })}
    >
      <CircularProgress
        size={size}
        {...props}
        className={clsx(classes.yellow, {
          [classes.green]: inAdminView(role, companySelected),
          [classes.gray]: inSuperAdminView(role, companySelected),
          [classes.blue]: inOperatorView(role, companySelected),
        })}
      />
    </Grid>
  );
};

const mapStateToProps = ({
  authenticate: { companySelected, data },
}: ApplicationState) => ({
  companySelected,
  role: data?.role,
});

export default connect(mapStateToProps, {})(Loading);
